module.exports = __webpack_public_path__ + "static/media/Queen of Wands.35a58672.png";